<template>
  <div class="item-container">
    <transition name="fade" appear>
      <div v-show="show" class="item" :style="`background-image: url('${item.imageURL}')`" @click="onClick">
        <div class="left-title">
          <h2 class="label">{{ item.title }}</h2>
        </div>
        <div class="right-title">
          <div class="label">{{ item.platform }} </div>
          <div class="flag-icon" :class="`flag-icon-${item.country.toLowerCase()}`"></div>
        </div>
        <div v-if="isLoggedIn" @click.stop.prevent="onDelete" class="delete"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    item: {
      required: true,
    },
    delay: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    isLoggedIn() {
      return !!window.EventBus.user;
    },
  },
  methods: {
    onClick() {
      const query = Object.assign({}, this.$route.query);
      query.id = this.item.key;
      this.$router.replace({ query });
      EventBus.creative = this.item;
    },
    onDelete() {
      this.$emit('delete', this.item);
    },
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, this.delay);
  },
};
</script>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .item-container {
    position: relative;

    @include mobile() {
      width: 100%;
    };
    @include tablet() {
      width: 50%;
    }
    @include widescreen() {
      width: calc(100% / 3);
    };

    height: 300px;
  }

  .item {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }

  .label {
    text-transform: uppercase;
    color: #FFF;
    font-size: 14.6667px;
    font-weight: 400;
    font-size: 0.8em;
    letter-spacing: 0.1em;
    text-shadow: 0px 0px 4px #000;
  }

  .left-title {
    position: absolute;
    left: 2em;
    bottom: 1.5em;
    max-width: 50%;
  }

  .right-title {
    position: absolute;
    right: 2em;
    bottom: 1.5em;

    .label {
      display: inline;
    }

    .flag-icon {
      vertical-align: middle;
    }
  }

  .delete {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .fade-enter-active {
    transition: opacity 1.5s;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// Item.vue?4804da4c